import { useSearchParams } from "react-router-dom";
import Orders from "@/pages/Orders";
import LmoRegister from "@/pages/LmoRegister";
import ServiceReportsRegister from "@/pages/ServiceReportsRegister";

const TABS = [["lm", "LMR / LMP / LMPP"], ["lms", "LMS"], ["lmo", "LMO"], ["sr", "Service Reports Register"]];

// One LM Register with a tab per LM family
export default function LmRegister() {
  const [sp, setSp] = useSearchParams();
  const tab = TABS.some(([k]) => k === sp.get("tab")) ? sp.get("tab") : "lm";
  return (
    <div data-testid="lm-register-page">
      <div className="mb-4 flex flex-wrap gap-1 border-b border-slate-200" data-testid="lm-register-tabs">
        {TABS.map(([k, l]) => <button key={k} onClick={() => setSp({ tab: k })} data-testid={`lm-register-tab-${k}`}
          className={`-mb-px border-b-2 px-3 py-2 text-sm transition-colors ${tab === k ? "border-sky-700 font-semibold text-sky-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>{l}</button>)}
      </div>
      {tab === "sr" ? <ServiceReportsRegister /> : tab === "lmo" ? <LmoRegister /> : <Orders key={tab} family={tab} />}
    </div>
  );
}
